import Vue from 'vue'
import VueRouter from 'vue-router'
import PageConfig from '@/views/PageConfig'
import PageViewer from '@/views/PageViewer'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        component: { template: '<div></div>' }
    },
    {
        path: '*/viewer.html',
        component: PageViewer
    },
    {
        path: '*/liveconfig.html',
        component: PageConfig
    },
    {
        path: '*/config.html',
        component: PageConfig
    },
    {
        path: '*/mobile.html',
        component: PageViewer
    },
]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router
